const dataInfo = {
    cosmonautica: {
        SaturnoV: {
            title: 'Cohete Saturno V',
            textContent: 'Fue un cohete diseñado y construido en EUA y utilizado en diversas misiones espaciales, la más conocida es la misión Apollo 11 en 1969',
            link: 'https://www.nasa.gov/centers/johnson/rocketpark/saturn_v.html',
            autor: {
                title: 'Saturn V blender',
                autor: 'AkshatSharma',
                contact: 'https://sketchfab.com/akshathjvghjmbhgm',
            }
        },
        transbordador: {
            title: 'Transbordador Espacial',
            textContent: 'Los transbodadores fueron naves espaciales diseñadas para realizar misiones fuera de nuestro planeta, llegado incluso a la Estación Espacial Internaciones entre 1981 y el 2011',
            link: 'https://www.nasa.gov/centers/dryden/espanol/FS-015-DFRC_espanol.html',
            autor: {
                title: 'Space Shuttle Atlantis',
                autor: 'paburoviii',
                contact: 'https://sketchfab.com/paburoviii',
            }
        },
        Curiosity: {
            title: 'Curiosity',
            textContent: 'El rover Curiosity fue lanzado a Marte el 26 de noviembre del 2011 y su misión es la de investigar si en Marte han existido las condiciones ambientales necesarias para el desarrollo de vida en forma de microorganismos',
            link: 'https://mars.nasa.gov/msl/mission/overview/',
            autor: {
                title: 'Curiosity Rover',
                autor: 'issem01',
                contact: 'https://sketchfab.com/issem01',
            }
        },
        FalconHeavy: {
            title: 'Falcon Heavy',
            textContent: 'En el 2018 la empresa de cohetes SpaceX realizó el primer lanzamiento del cohete Falcon Heavy, en la actualidad la familia de cohetes Falcon ha realizado diversos lanzamiento de satélites artificiales e incluso llevado astronautas a la Estación Espacial Internacional (EEI)',
            link: 'https://www.spacex.com/vehicles/falcon-heavy/',
            autor: {
                autor: 'Alex Conde',
                contact: 'https://www.facebook.com/alex.conde.792303',
                title: 'Falcon Heavy',
            }
        },
        EstacionEspacial: {
            title: 'EstacionEspacial',
            textContent: 'La Estación Espacial Internacional es una costrucción que se encuentra fuera de nuestro planeta y en el que habitan cómo máximo 6 personas al mismo tiempo, para realizar estudios sobre astrobiología, astronomía, física, producción de alimentos, comunicaciones, entre otros. Es financiada por la NASA, ROSCOSMOS, JAXA, Agencia Espacial Europea, Agencia Espacial Canadiense',
            link: 'https://www.esa.int/Science_Exploration/Human_and_Robotic_Exploration/International_Space_Station',
            autor: {
                title: ' Space Station International (FBX)',
                autor: 'oseg',
                contact: 'https://sketchfab.com/oseg',
            }
        },
        Estructura: {
            title: 'Modulo de Comando',
            textContent: 'El Módulo de Comando Columbia del Apolo 11 sirvió como espacio habitable para la tripulación de tres hombres durante la mayor parte de la primera misión tripulada de alunizaje en julio de 1969.',
            autor: {
                title: 'Apollo 11 Command Module (Combined)',
                autor: 'The Smithsonian Institution',
                contact: 'https://sketchfab.com/Smithsonian'
            }
        },
        Astronautas: {
            title: 'Alunizaje',
            textContent: 'Los astronautas de la misión Apollo XI fueron: Neil Armstrong, Michael Collins y Buzz Aldrin',
            autor: {
                title: 'The Moon Landing V.2',
                autor: 'MisterH',
                contact: 'https://sketchfab.com/TGVMisterH'
            }
        }
    },
    cosmonautica2: {
        SaturnoV: {
            title: 'Cohete Saturno V',
            textContent: 'Fue un cohete diseñado y construido en EUA y utilizado en diversas misiones espaciales, la más conocida es la misión Apollo 11 en 1969',
            link: 'https://www.nasa.gov/centers/johnson/rocketpark/saturn_v.html',
            autor: {
                title: 'Saturn V blender',
                autor: 'AkshatSharma',
                contact: 'https://sketchfab.com/akshathjvghjmbhgm',
            }
        },
        transbordador: {
            title: 'Transbordador Espacial',
            textContent: 'Los transbodadores fueron naves espaciales diseñadas para realizar misiones fuera de nuestro planeta, llegado incluso a la Estación Espacial Internaciones entre 1981 y el 2011',
            link: 'https://www.nasa.gov/centers/dryden/espanol/FS-015-DFRC_espanol.html',
            autor: {
                title: 'Space Shuttle Atlantis',
                autor: 'paburoviii',
                contact: 'https://sketchfab.com/paburoviii',
            }
        },
        Curiosity: {
            title: 'Curiosity',
            textContent: 'El rover Curiosity fue lanzado a Marte el 26 de noviembre del 2011 y su misión es la de investigar si en Marte han existido las condiciones ambientales necesarias para el desarrollo de vida en forma de microorganismos',
            link: 'https://mars.nasa.gov/msl/mission/overview/',
            autor: {
                title: 'Curiosity Rover',
                autor: 'issem01',
                contact: 'https://sketchfab.com/issem01',
            }
        },
        FalconHeavy: {
            title: 'Falcon Heavy',
            textContent: 'En el 2018 la empresa de cohetes SpaceX realizó el primer lanzamiento del cohete Falcon Heavy, en la actualidad la familia de cohetes Falcon ha realizado diversos lanzamiento de satélites artificiales e incluso llevado astronautas a la Estación Espacial Internacional (EEI)',
            link: 'https://www.spacex.com/vehicles/falcon-heavy/',
            autor: {
                autor: 'Alex Conde',
                contact: 'https://www.facebook.com/alex.conde.792303',
                title: 'Falcon Heavy',
            }
        },
        EstacionEspacial: {
            title: 'EstacionEspacial',
            textContent: 'La Estación Espacial Internacional es una costrucción que se encuentra fuera de nuestro planeta y en el que habitan cómo máximo 6 personas al mismo tiempo, para realizar estudios sobre astrobiología, astronomía, física, producción de alimentos, comunicaciones, entre otros. Es financiada por la NASA, ROSCOSMOS, JAXA, Agencia Espacial Europea, Agencia Espacial Canadiense',
            link: 'https://www.esa.int/Science_Exploration/Human_and_Robotic_Exploration/International_Space_Station',
            autor: {
                title: ' Space Station International (FBX)',
                autor: 'oseg',
                contact: 'https://sketchfab.com/oseg',
            }
        },
        Astronautas: {
            title: 'Alunizaje',
            textContent: 'Los astronautas de la misión Apollo XI fueron: Neil Armstrong, Michael Collins y Buzz Aldrin',
            autor: {
                title: 'The Moon Landing V.2',
                autor: 'MisterH',
                contact: 'https://sketchfab.com/TGVMisterH'
            }
        }
    },
    Cosmo_Mars: {
        marte: {
            title: 'A lo marciano',
            textContent: 'A lo marciano. Un vistazo al planeta rojo. Inspirada en la serie Mars de National Geographic. A lo marciano (The Martian Way), el título hace referencia a la novela corta escrita por Isaac Asimov (1920-1992) en 1952.',
            autor: {
                title: 'Marte v1.1',
                autor: 'uperesito',
                contact: 'https://sketchfab.com/uperesito',
            }
        }
    },
    marteInicio: {
        traje: {
            title: 'El traje de marte',
            textContent: 'El traje, tiene las adecuaciones necesarias para sobrevivir en el ambiente marciano Tecnología de bloqueo gravitacional. La gravedad es menor en Marte, este sistema permite al cuerpo humano la movilidad a pesar de esta diferencia, proporcionando mayor adhesión por medio de las botas. • Sistema anti-radiación. Protección contra la cantidad de radiación cósmica y solar que existe en Marte, para evitar la generación de enfermedades',
            autor: {
                title: 'Space X Dragon Suit',
                autor: 'Diuis',
                contact: 'https://sketchfab.com/Diuis',
            }
        }
    },
    trajeMars: {
        traje: {
            title: 'El traje de marte',
            textContent: 'El traje, tiene las adecuaciones necesarias para sobrevivir en el ambiente marciano Tecnología de bloqueo gravitacional. La gravedad es menor en Marte, este sistema permite al cuerpo humano la movilidad a pesar de esta diferencia, proporcionando mayor adhesión por medio de las botas. • Sistema anti-radiación. Protección contra la cantidad de radiación cósmica y solar que existe en Marte, para evitar la generación de enfermedades',
            autor: {
                title: 'Space X Dragon Suit',
                autor: 'Diuis',
                contact: 'https://sketchfab.com/Diuis',
            }
        },
        colonia: {
            title: 'Base marciana',
            textContent: 'Las casas habitacionales o también conocidos como Domos Geodesicos están construidos de una combinación de materiales con la finalidad de que la radiación no nos afecte mientras habitamos el planeta Marte; existen posibilidades de que estos domos sean subterráneos para protegernos, dichos domos se alimentan de energía solar mediante paneles solares. Nos podremos comunicar con la tierra mediante antenas.',
            autor: {
                title: 'Mars One Mission - Base',
                autor: 'admone',
                contact: 'https://sketchfab.com/admone',
            }
        },
        Curiosity: {
            title: 'El robert curiocity',
            textContent: 'Lanzado en el 2011 • Es el vehículo más grande puesto en Marte, pesa 899 kg. casi del tamaño de un automóvil. • Llego al Cráter Gale. • Ha enviado evidencia que sugiere rastro de moléculas orgánicas en este planeta. • Recibe indicaciones desde el centro de control en la Tierra. Desde ahí fue programado para cantarse “feliz cumpleaños” cuando cumple un ciclo más en Marte.',
            autor: {
                title: 'Curiosity Rover',
                autor: 'issem01',
                contact: 'https://sketchfab.com/issem01',
            }
        }
    },
    baseMarte: {
        colonia: {
            title: 'base',
            textContent: 'Se diseñó una colonia marciana, la cual contiene varios módulos: • Cuarto de control. Desde donde se vigilan todos los aspectos que involucran a la misión, pantallas que muestre el estado general de cada módulo. Computadora que puede recibir y enviar trasmisiones, comunicación a tierra, control de sistemas de soporte vital, entre otros. • Laboratorio. Cuarto estéril donde se analizan muestras de Marte y se realizan experimentos, debe contar con microscopios para dicho análisis. • Invernadero. Módulo vital para la permanencia en Marte, las plantas que podrían cultivar son: papas, lechugas, espinacas, col, berros, calabazas. ',
            autor: {
                title: 'Mars One Mission - Base',
                autor: 'admone',
                contact: 'https://sketchfab.com/admone',
            }
        },
        Curiosity: {
            title: 'El robert curiocity',
            textContent: 'Lanzado en el 2011 • Es el vehículo más grande puesto en Marte, pesa 899 kg. casi del tamaño de un automóvil. • Llego al Cráter Gale. • Ha enviado evidencia que sugiere rastro de moléculas orgánicas en este planeta. • Recibe indicaciones desde el centro de control en la Tierra. Desde ahí fue programado para cantarse “feliz cumpleaños” cuando cumple un ciclo más en Marte.',
            autor: {
                title: 'Curiosity Rover',
                autor: 'issem01',
                contact: 'https://sketchfab.com/issem01',
            }
        },
        domoGeodesico: {
            title: 'Domo geodesico',
            textContent: 'Maqueta basada en los estudios, teorías y análisis de cómo podría ser una colonia autosustentable. • Para poder sobrevivir tendrán que acostumbrarse a los cambios en el planeta, comenzando por la duración del día, que para Marte es de 24.6 horas y recibe el nombre de “Sol”',
            autor: {
                title: '48ft V2 Bamboo Dome',
                autor: 'Brian Korsedal',
                contact: 'https://sketchfab.com/BrianKorsedal',
            }
        }
    },
    robertCuriocity: {
        Curiosity: {
            title: 'El robert curiocity',
            textContent: 'Lanzado en el 2011 • Es el vehículo más grande puesto en Marte, pesa 899 kg. casi del tamaño de un automóvil. • Llego al Cráter Gale. • Ha enviado evidencia que sugiere rastro de moléculas orgánicas en este planeta. • Recibe indicaciones desde el centro de control en la Tierra. Desde ahí fue programado para cantarse “feliz cumpleaños” cuando cumple un ciclo más en Marte.',
            autor: {
                title: 'Curiosity Rover',
                autor: 'issem01',
                contact: 'https://sketchfab.com/issem01',
            }
        },
        domoGeodesico: {
            title: 'Domo geodesico',
            textContent: 'Maqueta basada en los estudios, teorías y análisis de cómo podría ser una colonia autosustentable. • Para poder sobrevivir tendrán que acostumbrarse a los cambios en el planeta, comenzando por la duración del día, que para Marte es de 24.6 horas y recibe el nombre de “Sol”',
            autor: {
                title: '48ft V2 Bamboo Dome',
                autor: 'Brian Korsedal',
                contact: 'https://sketchfab.com/BrianKorsedal',
            }
        }
    },
    marteDomo: {
        domoGeodesico: {
            title: 'Domo geodesico',
            textContent: 'Maqueta basada en los estudios, teorías y análisis de cómo podría ser una colonia autosustentable. • Para poder sobrevivir tendrán que acostumbrarse a los cambios en el planeta, comenzando por la duración del día, que para Marte es de 24.6 horas y recibe el nombre de “Sol”',
            autor: {
                title: '48ft V2 Bamboo Dome',
                autor: 'Brian Korsedal',
                contact: 'https://sketchfab.com/BrianKorsedal',
            }
        }
    },
    sistemaSolar: {
        sol: {
            title: 'Sol',
            textContent: 'El, Sol, nuestra estrella, es el centro de nuestro sistema solar, cuya atracción gravitacional es tan potente que mantiene numerosos planetas, planetas enanos (como Plutón), cometas y meteoritos orbitando alrededor de él.',
            autor: {
                title: 'Sun animated test',
                autor: 'P3TroV',
                contact: 'https://sketchfab.com/P3TroV',
            }
        },
        mercurio: {
            title: 'Mercurio',
            textContent: 'Es el primer planeta del sistema solar, este es similar a la luna ya que posee crateres, los cuales son malformaciones geograficas generadas por el impacto de asteroides y meteoritos',
            autor: {
                title: 'Mercury', autor: 'Mieke Roth', contact: 'https://sketchfab.com/miekeroth',
            }
        },
        venus: {
            title: 'Venus',
            textContent: 'Es el segundo planeta del sistema solar, considerado como el planeta más caliente de este debido ha que mantiene una tempratura constante que ronda los 462 °C',
            autor: {
                title: 'Venus',
                autor: 'kongle',
                contact: 'https://sketchfab.com/minecraftnorge',
            }
        },
        tierra: {
            title: 'Tierra',
            textContent: 'Es el tercer planeta del sistema solar, el cual también recibe el nombre de planeta azul, debido a que la mayor composicion de este planeta es el liquido vital para el ser Humano "Agua"',
            autor: {
                title: 'Tierra',
                autor: 'kongle',
                contact: 'https://sketchfab.com/minecraftnorge',
            }
        },
        marte: {
            title: 'Marte',
            textContent: 'Es el cuarto planeta del sistema solar, también es conocido como el planeta rojo, y recibe este nombre por la gran cantidad de  óxido de hierro que se encuentra en la superficie de este planeta',
            autor: {
                title: 'Marte v1.1',
                autor: 'uperesito',
                contact: 'https://sketchfab.com/uperesito',
            }
        },
        jupiter: {
            title: 'Jupiter',
            textContent: 'Es el quinto planeta del sistema solar, ádemas es el planeta más grande del sistema solar, junto con Saturno son llamados gigantes de gas, ya que su composición se basa en su mayoría en ser una gigante burbuja de gas sin superficie definida.',
            autor: {
                title: 'Jupiter',
                autor: 'Mieke Roth',
                contact: 'https://sketchfab.com/miekeroth',
            }
        },
        saturno: {
            title: 'Saturno',
            textContent: 'Es el sexto planeta del sistema solar, es un planeta que posee anillos, pero cabe mencionar que tanto Júpiter, Saturno, Urano y neptuno los poseen, pero no son tan visibles como los de Saturno, hechos principalmente de hielo, roca y gases.',
            autor: {
                title: 'Saturno v1.1',
                autor: 'uperesito',
                contact: 'https://sketchfab.com/uperesito',
            }
        },
        urano: {
            title: 'Urano',
            textContent: 'Es el septimo planeta de nuestro sistema solar,tanto este planeta como Neptuno estan compuestos por amoniaco, agua, hielo y otros componentes, ádemas es caracteristico por su color azul turquesa y la forma peculicar de girar.',
            autor: {
                title: 'Urano',
                autor: 'uperesito',
                contact: 'https://sketchfab.com/uperesito',
            }
        },
        neptuno: {
            title: 'Neptuno',
            textContent: 'Es el octavop y ultimo planeta de nuestro sistema solar,tanto este planeta como Urano estan compuestos por amoniaco, agua, hielo y otros componentes, ádemas de que este se caracterisa por su color azul oscuro y las temperaturas mas bajas teniendo su temperatura maxima la cual ronda en los -200°C.',
            autor: {
                title: 'Neptune',
                autor: 'Akshat',
                contact: 'https://sketchfab.com/shooter24994',
            }
        },
        pluton: {
            title: 'Pluton',
            textContent: ' Plutón un planeta enano en vez de un planeta más del Sistema Solar',
            autor: {

            }
        }
    },
    Mural: {
        parker: {
            title: 'Sonda Parker',
            textContent: 'Sonda espacial de la NASA que planeo rodear el sol. El paso de la nave a través de la corona solar ha permitido un muestreo sin precedentes de sus partículas y campos magnéticos',
            autor: {

            }
        },
        yuriGagarin: {
            title: 'Yuri Gagarin',
            textContent: 'Fue el primer ser humano en el espacio en 1961',
            autor: {

            }
        },
        astronauta: {
            title: 'Astronauta convencional',
            textContent: 'Las caracteristicas que destacan es el color, ya que no fue seleccionado al hazar ademas es una nave inegrada devido a que prove de oxigeno y proyeje de la radiacion',
            autor: {

            }
        },
        sputnik: {
            title: 'Sputnik II',
            textContent: 'Fue el primer ser vivo lanzado al espacio en 1957 ',
            autor: {

            }
        },
        valentina: {
            title: 'Valentina Tereshkova',
            textContent: 'Fue la primera mujer en el espacio en 1963',
            autor: {

            }
        },
        ham: {
            title: 'Chimpance Ham',
            textContent: 'Chimpance enviando en 1961 por los estados Unidos al espacio, fue el primer hominido en volar al espacio exterior',
            autor: {

            }
        },
        felicette: {
            title: 'Gata Felicette',
            textContent: 'Gata francesa enviada en 1963 al espacio exterior',
            autor: {

            }
        },
        cassini: {
            title: 'Sonda Cassini',
            textContent: 'info',
            autor: {

            }
        }
    }
}

export default dataInfo;